import { render } from "./MonitoringDisclaimer.vue?vue&type=template&id=d9bef952&ts=true"
import script from "./MonitoringDisclaimer.vue?vue&type=script&lang=ts"
export * from "./MonitoringDisclaimer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__